var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeakOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,800 H 800 V 0 H 0 Z",
    id: "path850"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583,
    style: {
      fill: "#00ff00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g848",
    clipPath: "url(#clipPath852)",
    transform: "matrix(0.07061323,0,0,-0.07061325,9.2547045,65.745304)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g854",
    transform: "translate(576.6811,461.518)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -1.212 C 6.456,-20.13 9.963,-40.414 9.963,-61.518 9.963,-82.622 6.456,-102.906 0,-121.824 v -1.212 l 106.552,61.518 z",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path856"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g858",
    transform: "translate(568.4322,318.5674)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -0.893,-0.893 C -19.088,-37.852 -49.148,-67.911 -86.107,-86.107 L -87,-87 31.844,-118.844 Z",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g862",
    transform: "translate(552.5737,400)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-84.264 -68.31,-152.574 -152.574,-152.574 -84.264,0 -152.573,68.31 -152.573,152.574 0,84.264 68.309,152.574 152.573,152.574 C -68.31,152.574 0,84.264 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g866",
    transform: "translate(400,213.3561)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -21.104,0 -41.387,3.507 -60.306,9.963 h -1.212 L 0,-96.589 61.518,9.963 H 60.306 C 41.387,3.507 21.104,0 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path868"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g870",
    transform: "translate(232.4606,317.6746)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.893,0.893 -31.844,-118.844 118.844,31.844 -0.893,0.893 C 48.255,-67.018 18.196,-36.959 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path872"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g874",
    transform: "translate(213.356,400)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,21.104 3.507,41.388 9.963,60.306 v 1.212 L -96.589,0 9.963,-61.518 v 1.212 C 3.507,-41.388 0,-21.104 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g878",
    transform: "translate(232.4607,482.3255)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 18.195,36.959 48.255,67.018 85.214,85.214 L 86.107,86.107 -32.737,117.951 -0.893,-0.893 Z",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path880"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g882",
    transform: "translate(400,586.644)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 21.104,0 41.387,-3.507 60.306,-9.963 h 1.212 L 0,96.589 -61.518,-9.963 h 1.212 C -41.387,-3.507 -21.104,0 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path884"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g886",
    transform: "translate(567.5393,482.3255)",
    style: {
      strokeWidth: 18.8821
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0.893,-0.893 32.737,117.951 -86.107,86.107 -85.214,85.214 C -48.255,67.018 -18.195,36.959 0,0",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 18.8821
    },
    id: "path888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakOff);
export default __webpack_public_path__ + "static/media/LeakOff.10d647a7097072ec73a9f0d660883c03.svg";
export { ForwardRef as ReactComponent };